import { BaseStorageService } from '@core/services/base-storage.service';
import { Injectable } from '@angular/core';
import { CalendarViewType } from '../enums/calendar-view-type.enum';

@Injectable({
  providedIn: 'root'
})
export class ProjectsTimelineStorageService extends BaseStorageService {
  constructor() {
    super();
  }

  get TimelineView(): CalendarViewType {
    const note = this.get('TimelineView');
    return !!note ? note : CalendarViewType.resourceTimelineWeek;
  }

  set TimelineView(timelineView: CalendarViewType) {
    this.put('TimelineView', timelineView);
  }

  get TimelineResourcesView(): CalendarViewType {
    const note = this.get('TimelineResourcesView');
    return !!note ? note : CalendarViewType.resourceTimelineWeek;
  }

  set TimelineResourcesView(timelineView: CalendarViewType) {
    this.put('TimelineResourcesView', timelineView);
  }
}
